let primary = '#A01313';
let primaryLight = '#A013131e';

export const palette = {
  alternate: {
    main: '#F0F7FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: primary,
    contrastText: '#FFF',
    light: primaryLight,
  },
  secondary: {
    main: '#FDF1D0',
    contrastText: '#14142B',
  },
  text: {
    primary: '#14142B',
    secondary: '#64748B',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    error: '#FD3E60'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#FAEDCD',
    paper: '#FFF',
    default: '#FFF',
    footer: '#002855',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: primary,
    tableSubhead: primaryLight,
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
  },
  verticalBar: {
    used: primary,
    unused: '#fbecce',
    unlimited: '#C0C0C0',
  }
};
